export const GT_ACCESS_TOKEN = 'GT_ACCESS_TOKEN'
export const GT_VERSION = VERSION // eslint-disable-line
export const GT_COMMENT = 'GT_COMMENT'
export const GT_ANONYMOUS_NAME = 'GT_ANONYMOUS_NAME'
export const GT_COMMENT_COUNT = 'GT_COMMENT_COUNT'


export const GT_CACHE_KEY_COMMENT = "GT_COMMENT_CACHE"
export const ONE_DAY = 24 * 60 * 60


// WEBPACK FOOTER //
// ./const.js